import palette from '../palette';

export default {
  root: {},
  avatar: {
    border: `2px solid ${palette.background.paper}`,
    marginLeft: -4,
  },
};
